import { availableLanguagesReducer } from './availableLanguages/slice';
import { erpSystemReducer } from './erpSystem/slice';
import { salesOrganizationReducer } from './salesOrganisation/slice';
import { shoppingCartReducer } from './shoppingCart/slice';
import { userReducer } from './user/slice';

import { itemsReducer } from './items/slice';
import { singleItemReducer } from './singleItem/slice';
import { attributesReducer } from './attributes/slice';
import { shapeValidationReducer } from './shapeValidation/slice';

import { shapeVisualizationReducer } from './shapeVisualization/slice';
import { paginationReducer } from './pagination/slice';
import { stepReducer } from './step/slice';
import { addToCartReducer } from './addToCart/slice';
import { notificationsReducer } from './notifications/slice';
import { modalReducer } from './modal/slice';
import { gasketsReducer } from './gaskets/slice';
// [IMPORT NEW REDUCER ABOVE] < Needed for generating containers seamlessly

const reducers = {
  availableLanguages: availableLanguagesReducer,
  erpSystem: erpSystemReducer,
  salesOrganization: salesOrganizationReducer,
  shoppingCart: shoppingCartReducer,
  user: userReducer,
  attributes: attributesReducer,
  items: itemsReducer,
  singleItem: singleItemReducer,
  shapeValidation: shapeValidationReducer,
  shapeVisualization: shapeVisualizationReducer,
  pagination: paginationReducer,
  step: stepReducer,
  addToCart: addToCartReducer,
  notifications: notificationsReducer,
  modal: modalReducer,
  gaskets: gasketsReducer,
  // [ADD NEW REDUCER KEY ABOVE] < Needed for generating containers seamlessly
};

export { reducers };
